export default "__VITE_ASSET__9fBmpTye__"